import { initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyBo3Tcq5K_9uxKdBEnoAEM9yURHAR0RsOY",
    authDomain: "testreact-96f2a.firebaseapp.com",
    projectId: "testreact-96f2a",
    storageBucket: "testreact-96f2a.firebasestorage.app",
    messagingSenderId: "26463534827",
    appId: "1:26463534827:web:c0a5194a9d88bc2c5308ae"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);